'use strict';

module.exports = {
    stringify: function stringify(url, data) {
        if (!data) return url;

        var param = [];
        for (var key in data) {
            if (data.hasOwnProperty(key)) {
                param.push(key + '=' + data[key]);
            }
        }

        return ~url.indexOf('?') ? url + '&' + param.join('&') : url + '?' + param.join('&');
    },
    // 1. url中有name参数, value不为空, 更新参数
    // 2. url中有name参数, value为空, 删除参数
    // 3. url中无name参数, value不为空, 增加参数
    replaceParam: function replaceParam(url, name, value) {
        if (!url || !name) return url;

        try {
            var pattern = new RegExp('(&' + name + '=)' + '([^\\?&]+)(&?)'); // eg: /(&webVersion=)([^\?&]+)(&?)/
            if (pattern.test(url)) {
                if (value) {
                    url = url.replace(pattern, '$1' + value + '$3');
                } else {
                    url = url.replace(pattern, '$3');
                }
            } else if (value) {
                var temp = {};
                temp[name] = value;
                url = this.stringify(url, temp);
            }
        } catch (e) {}

        return url;
    }
};